/** basic.eventType */
export default {
    eventTitle: "Типы событий",
    eventIsOpen: "Переключатель событий",
    alarmEvent: "Событие тревоги",
    faultEvent: "Событие неисправности",
    heartbeatEvent: "Событие heartbeat",
    OffLineEvent: "Событие: устройство офлайн",
    OnLineEvent: "Событие: устройство онлайн",
}

